import {
  DocumentTaskCreatedPayload,
  MessagePayload,
  QuestionTaskCreatedPayload,
  SectionTaskCreatedPayload,
  TaskDetailEvents,
  TaskInstanceDetail,
  TaskStatus,
  ThreadMessage,
} from '@data-access/tasks/types';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';

export const TASK_DETAIL_EVENTS: TaskDetailEvents = eventGroup({
  events: {
    addEntityToTask: type<{
      data: unknown;
      workspaceID: string;
    }>(),
    // TODO: implement assign task
    assignTask: type<{
      assigneeId: string | null;
      taskInstanceId: string;
      workspaceID: string;
    }>(),
    bulkUpdateTaskStatus: type<{
      workspaceID: string;
      taskInstanceIds: string[];
      toStatus: TaskStatus;
    }>(),
    clearTaskDetail: type<void>(),
    createDocumentTask: type<{
      workspaceID: string;
      payload: DocumentTaskCreatedPayload;
    }>(),
    createQuestionTask: type<{
      workspaceID: string;
      payload: QuestionTaskCreatedPayload;
    }>(),
    createSectionTask: type<{
      workspaceID: string;
      payload: SectionTaskCreatedPayload;
    }>(),
    createTaskMessage: type<{
      workspaceID: string;
      taskInstanceId: string;
      message: MessagePayload;
    }>(),
    exportThreadMessages: type<{
      workspaceID: string;
      threadId: string;
    }>(),
    getTaskDetail: type<{
      workspaceID: string;
      taskInstanceId: string;
    }>(),
    getTaskMessages: type<{
      workspaceID: string;
      threadId: string;
    }>(),
    patchMessages: type<{ messages: ThreadMessage[] }>(),
    patchTaskDetail: type<{
      taskDetail: TaskInstanceDetail | null;
      error: Error | null;
      messageCommunicationEstablished: boolean;
      lastRefreshedTaskId: string;
    }>(),
    patchTaskMessages: type<{ messages: ThreadMessage[] }>(),
    refreshTaskDetail: type<{ workspaceId: string; taskDetailId: string }>(),
    searchDocumentTask: type<{
      workspaceID: string;
      payload: DocumentTaskCreatedPayload;
    }>(),
    searchQuestionTask: type<{
      workspaceID: string;
      payload: QuestionTaskCreatedPayload;
    }>(),
    searchSectionTask: type<{
      workspaceID: string;
      payload: SectionTaskCreatedPayload;
    }>(),
    /** Event to update the status of a task */
    updateTaskStatus: type<{
      status: TaskStatus;
      taskInstanceId: string;
      workspaceID: string;
    }>(),
  },
  source: 'Task Detail Signal Store',
});
